// import icons in the folder
import user from './profile-1-color-gray.svg';
import lock from './lock-color-gray.svg';
// export as one large object
export { user, lock };


// WEBPACK FOOTER //
// ./src/img/icons/index.js